export default __webpack_public_path__ + "assets/myob_logo.971b8150.png";